import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Breadcrumbs from '../../../common-elements/breadcrumbs/Breadcrumbs'
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import { PaymentGatewayColumns } from '../../../data/master-settings/PaymentList'
import { tableHeaderStyles } from '../../../styles/ReactSelectStyles'
import { SMSData } from '../sms-gateway/SMS'
import DataTable from 'react-data-table-component'
import SearchBar from '../../../common-elements/search-bar/SearchBar'
export const PaymentGatewayData = [
  {
    "payment_gateway_id": 1,
    "gateway_name": "Stripe",
    "provider_name": "Stripe, Inc.",
    "type": "Online Payments & Subscriptions",
    "dashboard_url": "https://dashboard.stripe.com",
    "api_documentation_url": "https://stripe.com/docs/api",
    "supported_regions": "Global",
    "status": "Default",
    "Method": "Live",
     // Sandbox URLs
    "sandbox_payment_url": "https://api.stripe.com/v1/test/charges",
    "sandbox_status_url": "https://api.stripe.com/v1/test/charges/status",
     "sandbox_refund_url": "https://api.stripe.com/v1/test/refunds",
     "sandbox_recharge_url": "https://dashboard.stripe.com/test/billing",
     // Live URLs
     "live_payment_url": "https://api.stripe.com/v1/charges",
     "live_status_url": "https://api.stripe.com/v1/charges/status",
    "live_refund_url": "https://api.stripe.com/v1/refunds",
     "live_recharge_url": "https://dashboard.stripe.com/billing",
  },
  {
    "payment_gateway_id": 2,
    "gateway_name": "PayPal",
    "provider_name": "PayPal Holdings, Inc.",
    "type": "Digital Wallets & Online Payments",
    "dashboard_url": "https://www.paypal.com/mep/dashboard",
    "api_documentation_url": "https://developer.paypal.com/home",
    "supported_regions": "Global",
    "status": "StandBy",
    "Method": "Live",
    // Sandbox URLs
   " sandbox_payment_url": "https://api.razorpay.com/v1/test/payments",
   " sandbox_status_url": "https://api.razorpay.com/v1/test/payments/status",
    "sandbox_refund_url": "https://api.razorpay.com/v1/test/refunds",
   " sandbox_recharge_url": "https://dashboard.razorpay.com/test/app/subscriptions",
    // Live URLs
   "live_payment_url": "https://api.razorpay.com/v1/payments",
    "live_status_url": "https://api.razorpay.com/v1/payments/status",
    "live_refund_url": "https://api.razorpay.com/v1/refunds",
   "live_recharge_url": "https://dashboard.razorpay.com/app/subscriptions",

  },
  {
    "payment_gateway_id": 3,
    "gateway_name": "Razorpay",
    "provider_name": "Razorpay Software Private Limited",
    "type": "Indian Payment Gateway",
    "dashboard_url": "https://dashboard.razorpay.com",
    "api_documentation_url": "https://razorpay.com/docs/",
    "supported_regions": "India",
    "status": "StandBy",
    "Method": "Sandbox"
  },
  {
    "payment_gateway_id": 4,
    "gateway_name": "Braintree",
    "provider_name": "Braintree (a PayPal service)",
    "type": "Online Payments",
    "dashboard_url": "https://www.braintreegateway.com/login",
    "api_documentation_url": "https://developer.braintreepayments.com/",
    "supported_regions": "Multiple",
    "status": "StandBy",
    "Method": "Sandbox"
  },
  {
    "payment_gateway_id": 5,
    "gateway_name": "2Checkout",
    "provider_name": "Verifone (formerly 2Checkout)",
    "type": "Global Online Payments",
    "dashboard_url": "https://secure.2checkout.com/cpanel/login.php",
    "api_documentation_url": "https://www.2checkout.com/documentation/",
    "supported_regions": "Global",
    "status": "StandBy",
    "Method": "Live"
  }
];
function Payment() {
  const {t}=useTranslation()
  const [searchText, setSearchText] = useState("");
  return (
    <div>
     <Breadcrumbs
          mainTitle={t("PaymentGateway")}
          parent={t("MasterSetings")}
        />
         <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
              <div className="list-product-header">
            
              <div className="d-flex justify-content-between align-items-center mb-3">
                   
                    <SearchBar
                      label={t("Search")}
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      placeholder={t("SearchByLeaveName")}
                    />
                    </div>
              </div>
              
                
                <div className="list-product">
                  <div className="table-responsive" >
                    <DataTable data={PaymentGatewayData} columns={PaymentGatewayColumns(t)}   customStyles={tableHeaderStyles} striped highlightOnHover pagination  />
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

    </div>
  )
}

export default Payment

